// extracted by mini-css-extract-plugin
export default {"locations_page":"user-list_locations_page__T+hrA","search_add_btn":"user-list_search_add_btn__M2KQ+"};